import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderProductionLotAllocationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrderProductionLotAllocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrderProductionLotAllocationDocumentSortInput> | Types.OrderProductionLotAllocationDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderProductionLotAllocationsQuery = { __typename?: 'Query', orderProductionLotAllocations?: { __typename?: 'OrderProductionLotAllocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OrderProductionLotAllocationFragmentFragment = { __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO };

export type GetOrderProductionLotAllocationByIdQueryVariables = Types.Exact<{
  allocationId: Types.Scalars['String']['input'];
}>;


export type GetOrderProductionLotAllocationByIdQuery = { __typename?: 'Query', orderProductionLotAllocationById?: { __typename?: 'OrderProductionLotAllocationDocument', id: string, tenantId: string, orderId: string, orderLineId: string, productionLotId: string, allocatedQty: number, peggedQty: number, orderedQty: number, lotQty: number, readyWeek: Types.TDateISO, status: Types.OrderProductionLotAllocationStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO } | null };

export type GetOpenOrdersForLotItemQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  dateFrom: Types.Scalars['DateTime']['input'];
  dateTo: Types.Scalars['DateTime']['input'];
}>;


export type GetOpenOrdersForLotItemQuery = { __typename?: 'Query', reportOpenOrdersByItemData: { __typename?: 'ReportOpenOrdersByItemDataPayload', truncatedByLimit: boolean, data: Array<{ __typename?: 'ReportOpenOrdersByItemData', itemId: string, itemName: string, customerOrders: Array<{ __typename?: 'ReportOpenOrdersByItemOrder', orderId: string, orderNumber: string, poNumber: string, customerName: string, status: string, expectedDeliveryDate: Types.TDateISO }> }> } };

export type GetOrderLinesForLotItemQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrderLineItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrderLineItemDocumentSortInput> | Types.OrderLineItemDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderLinesForLotItemQuery = { __typename?: 'Query', orderLineItems?: { __typename?: 'OrderLineItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderLineItemDocument', lineItemId: string, orderId: string, lineNumber: number, name: string, orderedQuantity?: number | null, acknowledgedQuantity?: number | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionLotOpenAllocationsQueryVariables = Types.Exact<{
  productionLotIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetProductionLotOpenAllocationsQuery = { __typename?: 'Query', productionLotOpenAllocations: { __typename?: 'ProductionLotOpenAllocationsPayload', allocations?: Array<{ __typename?: 'ProductionLotOpenAllocation', productionLotId: string, kind: Types.ProductionLotAllocationKind, orderId: string, orderNumber: string, orderStatus: Types.OrderStatus, customerName: string, lineItemId: string, itemName: string, expectedDeliveryDate: Types.TDateISO, quantity: number }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const OrderProductionLotAllocationFragmentFragmentDoc = new TypedDocumentString(`
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}
    `, {"fragmentName":"OrderProductionLotAllocationFragment"});
export const GetOrderProductionLotAllocationsDocument = new TypedDocumentString(`
    query GetOrderProductionLotAllocations($where: OrderProductionLotAllocationDocumentFilterInput, $order: [OrderProductionLotAllocationDocumentSortInput!], $first: Int, $after: String) {
  orderProductionLotAllocations(
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...OrderProductionLotAllocationFragment
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderProductionLotAllocationByIdDocument = new TypedDocumentString(`
    query GetOrderProductionLotAllocationById($allocationId: String!) {
  orderProductionLotAllocationById(allocationId: $allocationId) {
    ...OrderProductionLotAllocationFragment
  }
}
    fragment OrderProductionLotAllocationFragment on OrderProductionLotAllocationDocument {
  id
  tenantId
  orderId
  orderLineId
  productionLotId
  allocatedQty
  peggedQty
  orderedQty
  lotQty
  readyWeek
  status
  createdAt
  updatedAt
}`);
export const GetOpenOrdersForLotItemDocument = new TypedDocumentString(`
    query GetOpenOrdersForLotItem($itemId: String!, $dateFrom: DateTime!, $dateTo: DateTime!) {
  reportOpenOrdersByItemData(
    itemId: $itemId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    truncatedByLimit
    data {
      itemId
      itemName
      customerOrders {
        orderId
        orderNumber
        poNumber
        customerName
        status
        expectedDeliveryDate
      }
    }
  }
}
    `);
export const GetOrderLinesForLotItemDocument = new TypedDocumentString(`
    query GetOrderLinesForLotItem($where: OrderLineItemDocumentFilterInput, $order: [OrderLineItemDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orderLineItems(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      lineItemId
      orderId
      lineNumber
      name
      orderedQuantity
      acknowledgedQuantity
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionLotOpenAllocationsDocument = new TypedDocumentString(`
    query GetProductionLotOpenAllocations($productionLotIds: [String!]!) {
  productionLotOpenAllocations(productionLotIds: $productionLotIds) {
    allocations {
      productionLotId
      kind
      orderId
      orderNumber
      orderStatus
      customerName
      lineItemId
      itemName
      expectedDeliveryDate
      quantity
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderProductionLotAllocations: build.query<GetOrderProductionLotAllocationsQuery, GetOrderProductionLotAllocationsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderProductionLotAllocationsDocument, variables })
    }),
    GetOrderProductionLotAllocationById: build.query<GetOrderProductionLotAllocationByIdQuery, GetOrderProductionLotAllocationByIdQueryVariables>({
      query: (variables) => ({ document: GetOrderProductionLotAllocationByIdDocument, variables })
    }),
    GetOpenOrdersForLotItem: build.query<GetOpenOrdersForLotItemQuery, GetOpenOrdersForLotItemQueryVariables>({
      query: (variables) => ({ document: GetOpenOrdersForLotItemDocument, variables })
    }),
    GetOrderLinesForLotItem: build.query<GetOrderLinesForLotItemQuery, GetOrderLinesForLotItemQueryVariables | void>({
      query: (variables) => ({ document: GetOrderLinesForLotItemDocument, variables })
    }),
    GetProductionLotOpenAllocations: build.query<GetProductionLotOpenAllocationsQuery, GetProductionLotOpenAllocationsQueryVariables>({
      query: (variables) => ({ document: GetProductionLotOpenAllocationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderProductionLotAllocationsQuery, useLazyGetOrderProductionLotAllocationsQuery, useGetOrderProductionLotAllocationByIdQuery, useLazyGetOrderProductionLotAllocationByIdQuery, useGetOpenOrdersForLotItemQuery, useLazyGetOpenOrdersForLotItemQuery, useGetOrderLinesForLotItemQuery, useLazyGetOrderLinesForLotItemQuery, useGetProductionLotOpenAllocationsQuery, useLazyGetProductionLotOpenAllocationsQuery } = injectedRtkApi;
